<template>
  <h1>Depositing to WSB</h1>
  <p>
    You can deposit money on your wallet. It's Easy!<br>
    Select your deposit method.<br>
    <a v-if="username">User: {{ username }}</a> 
  </p>
  <!-- <p><strong>Up to 6% Real Money Bonus on all Deposits!</strong></p> -->
  
  <DepositMethodsGrid
    :username="username"
    @method-selected="handleMethodSelected"
    @info-requested="handleInfoRequested"
  />
</template>

<script>
import common from '@/scripts/common.js';
import DepositMethodsGrid from '@/components/DepositMethodsGridMalawi.vue';

export default {
  components: {
    DepositMethodsGrid
  },
  data() {
    return {
      username: this.$route.query.username || "", // Obtener el parámetro de la URL
      amount: null,
      showError: false,
      responseMessage: "",  // Mensaje de la respuesta
      responseType: "",     // Tipo de mensaje (exito / error)
      showDepositForm: true, // Controla la visibilidad del formulario de depósito
      isLoading: false,      // Controla si la solicitud está en proceso
    };
  },
  methods: { 
    handleMethodSelected(methodName) {
      const methodHandlers = {
        'airtel': this.pagarAirtel,
        'tnm': this.pagarTnm,
        'paychangu': this.pagarPaychangu,
        'paychangu-card': this.pagarPaychanguCard,
        'paychangu-bank': this.pagarPaychanguBank,
        'paybill': this.infoPaybill,
        'paybill1': this.infoPaybill1,
        'paybill2': this.infoPaybill2,
        //'help': this.pagarHelpContact
      };

      const handler = methodHandlers[methodName];
      if (handler) {
        handler();
      }
    },

    handleInfoRequested(methodName) {
      const infoHandlers = {
        'airtel': this.infoAirtel,
        'tnm': this.infoTnm,
        'paychangu': this.infoPaychangu,
        'paychangu-card': this.infoPaychangu,
        'paychangu-bank': this.infoPaychangu,
        'paybill1': this.infoPaybill1,
        'paybill2': this.infoPaybill2,
        'paybill': this.infoPaybill
      };

      const handler = infoHandlers[methodName];
      if (handler) {
        handler();
      }
    },


    infoTnm() {
      window.parent.postMessage({ action: 'btnTnmInfo' }, '*');
    },

    infoPaychangu() {
      window.parent.postMessage({ action: 'btnPaychanguInfo' }, '*');
    },

    infoAirtel() {
      window.parent.postMessage({ action: 'btnAirtelInfo' }, '*');
    },
  
    infoPaybill2() {
      window.parent.postMessage({ action: 'btnPayBill2' }, '*');
    },

    infoPaybill1() {
      window.parent.postMessage({ action: 'btnPayBill1' }, '*');
    },

    infoPaybill() {
      window.parent.postMessage({ action: 'btnPayBill' }, '*');
    },

    async pagarTnm() {
      if (!this.username) {
        window.parent.postMessage({ action: 'btnLogin' }, '*');
      } else {
        window.parent.postMessage({ action: 'btnhiddeninfo' }, '*');
        console.log("Iniciando pago con TNM...");

        var maintenance = await common.checkMaintenanceMW("tnm");

        if (maintenance) {
          this.$router.push({ name: 'DepositMaintenanceMalawi', query: { username: this.$route.query.username } });
        } else {
          this.$router.push({ name: 'TnmDepositWebsite', query: { username: this.$route.query.username } });
        }
      }
    },

    async pagarPaychangu() {
      if (!this.username) {
        window.parent.postMessage({ action: 'btnLogin' }, '*');
      } else {
        window.parent.postMessage({ action: 'btnhiddeninfo' }, '*');
        console.log("Iniciando pago con Paychangu...");

        var maintenance = await common.checkMaintenanceMW("paychanguMobile");

        if (maintenance) {
          this.$router.push({ name: 'DepositMaintenanceMalawi', query: { username: this.$route.query.username } });
        } else {
          this.$router.push({ name: 'PaychanguMobileWebsite', query: { username: this.$route.query.username } });
        }
      }
    },

    async pagarPaychanguCard() {
      if (!this.username) {
        window.parent.postMessage({ action: 'btnLogin' }, '*');
      } else {
        window.parent.postMessage({ action: 'btnhiddeninfo' }, '*');
        console.log("Iniciando pago con Paychangu Debit/Credit Card...");

        var maintenance = await common.checkMaintenanceMW("paychanguCard");

        if (maintenance) {
          this.$router.push({ name: 'DepositMaintenanceMalawi', query: { username: this.$route.query.username } });
        } else {
          this.$router.push({ name: 'PaychanguCardWebsite', query: { username: this.$route.query.username } });
        }
      }
    },

    async pagarPaychanguBank() {
      if (!this.username) {
        window.parent.postMessage({ action: 'btnLogin' }, '*');
      } else {
        window.parent.postMessage({ action: 'btnhiddeninfo' }, '*');
        console.log("Iniciando deposito por Bank Transfer Paychangu...");

        var maintenance = await common.checkMaintenanceMW("paychanguBankTranfer");

        if (maintenance) {
          this.$router.push({ name: 'DepositMaintenanceMalawi', query: { username: this.$route.query.username } });
        } else {
          this.$router.push({ name: 'PaychanguBankTransferWebsite', query: { username: this.$route.query.username } });
        }
      }
    },

    async pagarAirtel() {
      if (!this.username) {
        window.parent.postMessage({ action: 'btnLogin' }, '*');
      } else {
        window.parent.postMessage({ action: 'btnhiddeninfo' }, '*');
        console.log("Iniciando pago con Airtel...");

        var maintenance = await common.checkMaintenanceMW("airtel");

        if (maintenance) {
          this.$router.push({ name: 'DepositMaintenanceMalawi', query: { username: this.$route.query.username } });
        } else {
          this.$router.push({ name: 'AirtelDepositWebsite', query: { username: this.$route.query.username } });
        }
      }
    },

    sendHeight() {
      const height = document.body.scrollHeight;
      window.parent.postMessage({ iframeHeight: height }, "*");
    }
  },

  mounted() {
    // Enviar altura inicial al cargarse el componente
    this.sendHeight();

    // También puedes agregar un listener para resize si lo deseas
    window.addEventListener("resize", this.sendHeight);
  },

  updated() {
    // Enviar altura después de que el DOM se actualice (por si hay cambios dinámicos)
    this.$nextTick(() => {
      this.sendHeight();
    });
  },

  beforeUnmount() {
    // Limpiar el listener si lo agregaste
    window.removeEventListener("resize", this.sendHeight);
  }
  
};
</script>

<style scoped>
body {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1 {
  color: #1a2332;
  text-align: center;
  font-weight: 800;
  padding: 25px 15px;
  font-size: 32px;
  margin-bottom: 10px;
  letter-spacing: -1px;
}

p {
  color: #555;
  text-align: center;
  font-size: 15px;
  line-height: 1.6;
  margin: 10px 0;
}

p a {
  color: #1a73e8;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

p a:hover {
  color: #1557b0;
  text-decoration: underline;
}

p strong {
  color: #000000;
  font-weight: 700;
}
</style>
